import React from 'react';

import { cn } from '../lib/utils';

export function Chip({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <div
      className={cn([
        'inline-flex items-center gap-1.5 rounded-md px-2 py-0.75 text-xs font-medium whitespace-nowrap',
        className,
      ])}
    >
      {children}
    </div>
  );
}
